import React from 'react';
import styles from './css.module.less';
import { SectionWrapper } from '@/src/components';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Select, Form } from '@/src/components/Antd';
import { Radio, Space } from 'antd';
import {
  Cnversion,
  //DecimalSeparator,
  //DisplayFormat,
  //ThousandsSeparator,
  // conversionOptions,
  decimalPositionOptions,
  ruleStartPosition,
} from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCurrency/constant';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { get } from 'lodash';
import { conversionOptions } from '../constant';
//storeCurrency.index.roundingof
const Item = Form.Item;
const CurrencyFormat = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const edit_currency_settings = true;
  const handleOnRenderRoundingExample = (roundingRule, decimalPosition) => {
    const position = ruleStartPosition(roundingRule);
    return `${replaceI18nVariables(
      getI18n('storeCurrency.index.roundingof'),
      'HKD',
      '1,245.7892',
      'HKD',
    )}
    ${(
      Math.floor(1245.7892 * Math.pow(10, position)) / Math.pow(10, position)
    ).toFixed(decimalPosition)}`;
  };

  const handleOnRenderTruncatingExample = (truncateRule, decimalPosition) => {
    const position = ruleStartPosition(truncateRule) || 0;
    return `   ${replaceI18nVariables(
      getI18n('storeCurrency.index.roundingof'),
      'CNY',
      '1,245.7892',
      'CNY',
    )}
    ${(
      Math.trunc(1245.7892 * Math.pow(10, position)) / Math.pow(10, position)
    ).toFixed(decimalPosition)}`;
  };

  return (
    <SectionWrapper
      className={styles.wrapper}
      containerClassName={styles.formatWrapperContainer}
      title={getI18n('storeCurrency.index.currencyFormat')}
      subtitle={getI18n('storeCurrency.index.currencyFormatSubtitle')}>
      <div className={styles.warpperBody}>
        <ItemWrapper
          containerClassName={styles.formatWrapperTop}
          title={
            <div>
              <span>{getI18n('storeCurrency.index.decimalPlaces')}</span>
              <span style={{ marginLeft: '12px', fontWeight: 400 }}>
                ( 0 - 9 )
              </span>
            </div>
          }>
          <Item name='decimalPosition'>
            <Select
              className={styles.select}
              size='large'
              // onChange={handleChangeDecimalPosition}
              // value={currencyConfig.decimalPosition}
              options={decimalPositionOptions}
              disabled={!edit_currency_settings}
            />
          </Item>
          {
            // (reportingCurrency?.code !== currencyConfig.currencyCode ||
            //   (reportingCurrency?.code !==
            //     currencyConfig.secondaryCurrencyCode &&
            //     !!currencyConfig.secondaryCurrencyCode)) // 修改-> 必须要有的field

            <ItemWrapper
              containerClassName={styles.bottomItemWrapper}
              title={getI18n('storeCurrency.index.conversionModeTitle')}
              bottomTitle={getI18n(
                'storeCurrency.index.conversionModeBottomTitle',
              )}>
              <Item name='conversionMode'>
                <Radio.Group
                  //   value={currencyConfig.conversionMode}
                  //   onChange={handleChangePropsViaEvent.bind(
                  //     this,
                  //     'conversionMode',
                  //   )}
                  disabled={!edit_currency_settings}>
                  <Space direction='vertical' className={styles.space}>
                    <div className={styles.item}>
                      <Radio value={Cnversion.Round}>
                        {getI18n('storeCurrency.index.roundnumbersdown')}
                      </Radio>
                      <div className={styles.body}>
                        <div className={styles.desc}>
                          {getI18n('storeCurrency.index.roundnumbersdowntip')}
                        </div>
                        <Item
                          shouldUpdate={(p, c) => {
                            return (
                              get(p, 'conversionMode') !==
                                get(c, 'conversionMode') ||
                              get(p, 'decimalPosition') !==
                                get(c, 'decimalPosition')
                            );
                          }}>
                          {({ getFieldValue }) => {
                            const mode = getFieldValue('conversionMode');
                            const decimalPosition =
                              getFieldValue('decimalPosition');
                            return mode === Cnversion.Round ? (
                              <React.Fragment>
                                <Item name='roundingRule'>
                                  <Select
                                    className={styles.select}
                                    size='large'
                                    //value={currencyConfig.roundingRule}
                                    options={conversionOptions({
                                      getI18n,
                                    }).slice(0, decimalPosition + 1)}
                                    // onChange={handleChangePropsViaValue.bind(
                                    //   this,
                                    //   'roundingRule',
                                    // )}
                                    disabled={!edit_currency_settings}
                                  />
                                </Item>
                                <span className={styles.exmaple}>
                                  <Item
                                    shouldUpdate={(p, c) => {
                                      return (
                                        get(p, 'conversionMode') !==
                                          get(c, 'conversionMode') ||
                                        get(p, 'decimalPosition') !==
                                          get(c, 'decimalPosition') ||
                                        get(p, 'roundingRule') !==
                                          get(c, 'roundingRule')
                                      );
                                    }}>
                                    {({ getFieldValue }) => {
                                      const roundingRule =
                                        getFieldValue('roundingRule');
                                      return handleOnRenderRoundingExample(
                                        roundingRule,
                                        decimalPosition,
                                      );
                                    }}
                                  </Item>
                                </span>
                              </React.Fragment>
                            ) : (
                              <React.Fragment></React.Fragment>
                            );
                          }}
                        </Item>
                        {/* {currencyConfig.conversionMode === Cnversion.Round && (
                          <>
                            <Select
                              className={styles.select}
                              size='large'
                              value={currencyConfig.roundingRule}
                              options={conversionOptions({
                                getI18n,
                              }).slice(0, currencyConfig.decimalPosition + 1)}
                              onChange={handleChangePropsViaValue.bind(
                                this,
                                'roundingRule',
                              )}
                              disabled={!edit_currency_settings}
                            />
                            <span className={styles.exmaple}>
                              {renderRoundingExample()}
                            </span>
                          </>
                        )} */}
                      </div>
                    </div>
                    <div className={styles.item}>
                      <Radio
                        value={Cnversion.Truncate}
                        disabled={!edit_currency_settings}>
                        {getI18n('storeCurrency.index.truncating')}
                      </Radio>
                      <div className={styles.body}>
                        <div className={styles.desc}>
                          {getI18n('storeCurrency.index.truncatingTip')}
                        </div>
                        <Item
                          shouldUpdate={(p, c) => {
                            return (
                              get(p, 'conversionMode') !==
                                get(c, 'conversionMode') ||
                              get(p, 'decimalPosition') !==
                                get(c, 'decimalPosition')
                            );
                          }}>
                          {({ getFieldValue }) => {
                            const mode = getFieldValue('conversionMode');
                            const decimalPosition =
                              getFieldValue('decimalPosition');
                            return mode === Cnversion.Truncate ? (
                              <React.Fragment>
                                <Item name='truncateRule'>
                                  <Select
                                    className={styles.select}
                                    size='large'
                                    //value={currencyConfig.roundingRule}
                                    options={conversionOptions({
                                      getI18n,
                                    }).slice(0, decimalPosition + 1)}
                                    // onChange={handleChangePropsViaValue.bind(
                                    //   this,
                                    //   'roundingRule',
                                    // )}
                                    disabled={!edit_currency_settings}
                                  />
                                </Item>
                                <span className={styles.exmaple}>
                                  <Item
                                    shouldUpdate={(p, c) => {
                                      //truncateRule, decimalPosition
                                      return (
                                        get(p, 'conversionMode') !==
                                          get(c, 'conversionMode') ||
                                        get(p, 'decimalPosition') !==
                                          get(c, 'decimalPosition') ||
                                        get(p, 'truncateRule') !==
                                          get(c, 'truncateRule')
                                      );
                                    }}>
                                    {({ getFieldValue }) => {
                                      const truncateRule =
                                        getFieldValue('truncateRule');
                                      return handleOnRenderTruncatingExample(
                                        truncateRule,
                                        decimalPosition,
                                      );
                                    }}
                                  </Item>
                                </span>
                              </React.Fragment>
                            ) : (
                              <React.Fragment></React.Fragment>
                            );
                          }}
                        </Item>
                        {/* {currencyConfig.conversionMode ===
                          Cnversion.Truncate && (
                          <>
                            <Select
                              className={styles.select}
                              size='large'
                              value={currencyConfig.truncateRule}
                              options={conversionOptions({
                                getI18n,
                              }).slice(0, currencyConfig.decimalPosition + 1)}
                              onChange={handleChangePropsViaValue.bind(
                                this,
                                'truncateRule',
                              )}
                              disabled={!edit_currency_settings}
                            />
                            <span className={styles.exmaple}>
                              {renderTruncatingExample()}
                            </span>
                          </>
                        )} */}
                      </div>
                    </div>
                  </Space>
                </Radio.Group>
              </Item>
            </ItemWrapper>
          }
        </ItemWrapper>
        {/* <ItemWrapper containerClassName={styles.formatWrapper}>
          <div className={styles.item}>
            <div className={styles.title}>
              {getI18n('storeCurrency.index.decimalSeparator')}
            </div>
            <Item name='decimalSeparator'>
              <Radio.Group
                //   value={currencyConfig.decimalSeparator}
                //   onChange={handleChangePropsViaEvent.bind(
                //     this,
                //     'decimalSeparator',
                //   )}
                disabled={!edit_currency_settings}>
                <Space direction={'vertical'}>
                  <Radio value={DecimalSeparator.POINT}>
                    {getI18n('storeCurrency.index.decimalpoint')} (.)
                  </Radio>
                  <Radio value={DecimalSeparator.COMMA}>
                    {getI18n('storeCurrency.index.decimalcomma')} (,)
                  </Radio>
                </Space>
              </Radio.Group>
            </Item>
          </div>
          <div className={styles.item}>
            <div className={styles.title}>
              {getI18n('storeCurrency.index.thousandsSeparator')}
            </div>
            <Item name='thousandsSeparator'>
              <Radio.Group
                // value={currencyConfig.thousandsSeparator}
                // onChange={handleChangePropsViaEvent.bind(
                //   this,
                //   'thousandsSeparator',
                // )}
                disabled={!edit_currency_settings}>
                <Space direction={'vertical'}>
                  <Radio value={ThousandsSeparator.NOT_USE}>
                    {getI18n('storeCurrency.index.notuse')}
                  </Radio>
                  <Radio value={ThousandsSeparator.COMMA}>
                    {getI18n('storeCurrency.index.comma')} (,)
                  </Radio>
                  <Radio value={ThousandsSeparator.POINT}>
                    {getI18n('storeCurrency.index.point')} (.)
                  </Radio>
                  <Radio value={ThousandsSeparator.SPACE}>
                    {getI18n('storeCurrency.index.space')}
                  </Radio>
                </Space>
              </Radio.Group>
            </Item>
          </div>
        </ItemWrapper> */}
      </div>
    </SectionWrapper>
  );
};
export default CurrencyFormat;
